import {useState} from 'react'

export type TLoader = {
  id: string
  isLoadingEditButton: boolean
}

export const useLoaderList = () => {
  const [loaderList, setLoaderList] = useState<Array<TLoader>>([])

  const isLoadingEditButton = (index: number) => {
    return loaderList[index].isLoadingEditButton
  }

  const onInitializeLoaderList = (data: any[]) => {
    setLoaderList(data.map((item: any) => ({id: item.id, isLoadingEditButton: false} as TLoader)))
  }

  const onUpdateLoaderListByIndex = (index: number) => {
    setLoaderList(
      loaderList.map((item, idx) => {
        if (idx === index) return {...item, isLoadingEditButton: true}
        return item
      })
    )
  }

  const onResetLoaderList = () => {
    setLoaderList(
      loaderList.map((item: any) => ({id: item.id, isLoadingEditButton: false} as TLoader))
    )
  }

  return {
    loaderList,
    isLoadingEditButton,
    onInitializeLoaderList,
    onUpdateLoaderListByIndex,
    onResetLoaderList,
  }
}
